import React, { useState, ReactNode } from 'react';
import * as events from '../../../../../lib/analytics/events';

import styles from './Question.module.scss';

export default function Question({
  title,
  page,
  children,
  index,
}: {
  title: string;
  page: string;
  children: ReactNode;
  index: number;
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.container}>
      <div
        className={styles.titleContainer}
        onClick={() => {
          setExpanded((value) => !value);
          events.FAQExpand(page, index);
        }}
      >
        <div className={styles.titleText}>{title}</div>
        <div className={styles.toggle}>{expanded ? '-' : '+'}</div>
      </div>
      {expanded && <div className={styles.body}>{children}</div>}
    </div>
  );
}
